const Editable = ({ active, view, edit }) => {
    return active ? edit : view;
};

export default Editable;